var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-view',{attrs:{"title":"Saldos por partidas presupuestales"}},[_c('div',{staticClass:"container-fluid mt-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('MomentoContable')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }